import '@fontsource-variable/archivo';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './estilos/tokens.css';
import './estilos/base.css';

import { App } from './App.tsx';
import { ErroApi } from './lib/api.ts';
import { ProvedorSessao } from './lib/sessao.tsx';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Sessao expirada e falta de permissao nao se resolvem tentando de novo.
      retry: (tentativa, erro) => {
        if (erro instanceof ErroApi && [401, 403, 404, 422].includes(erro.status)) return false;
        return tentativa < 2;
      },
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <ProvedorSessao>
          <App />
        </ProvedorSessao>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
